import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import t from '@instructure/quiz-i18n/es/format-message';
import { addError, addSuccess } from '../../common/actions/alerts';
import { getSpecificBanks } from './banks';
var pollingBanks = [];
var currentlyPolling = false;
export var addToPolling = function addToPolling(bankId, bankTitle) {
  var getSpecificBanksFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : getSpecificBanks;
  return function (dispatch) {
    pollingBanks.push({
      id: bankId,
      title: bankTitle
    });
    if (!currentlyPolling) {
      currentlyPolling = true;
      _handlePollingBanks(dispatch, getSpecificBanksFn);
    }
  };
};
export var removeFromPolling = function removeFromPolling(removeIds) {
  pollingBanks = pollingBanks.filter(function (bank) {
    return !removeIds.includes(bank.id);
  });
};
var _handlePollingBanks = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
    var getSpecificBanksFn,
      updatedPollingBanks,
      updatedPollingBankIds,
      finishedCopying,
      finishedCopyingIds,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          getSpecificBanksFn = _args.length > 1 && _args[1] !== undefined ? _args[1] : getSpecificBanks;
          _context.next = 3;
          return getSpecificBanksFn(pollingBanks.map(function (bank) {
            return bank.id;
          }))(dispatch);
        case 3:
          updatedPollingBanks = _context.sent;
          updatedPollingBankIds = updatedPollingBanks.map(function (updatedBank) {
            return updatedBank.id;
          }); // banks that now have status 'waiting' have finished successfully
          // banks that are no longer in the updated list but were in the previous list have
          // failed to copy and therefore were archived
          finishedCopying = updatedPollingBanks.filter(function (bank) {
            return bank.status === 'waiting';
          }).concat(pollingBanks.filter(function (prevBank) {
            return !updatedPollingBankIds.includes(prevBank.id);
          }));
          finishedCopying.forEach(function (bank) {
            var bankInfo = updatedPollingBanks.find(function (info) {
              return info.id == bank.id;
            });
            if ((bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.status) === 'waiting') {
              dispatch(addSuccess(t('Created "{name}" successfully! Duplicate can be seen in \'Shared with Me\' filter.', {
                name: bank.title
              })));
            } else if (!bankInfo) {
              dispatch(addError(t('Failed to create "{name}". Please try again.', {
                name: bank.title
              })));
            }
          });
          finishedCopyingIds = finishedCopying.map(function (bank) {
            return bank.id;
          });
          removeFromPolling(finishedCopyingIds);
          if (pollingBanks.length > 0) {
            setTimeout(function () {
              _handlePollingBanks(dispatch);
            }, 3000);
          } else {
            currentlyPolling = false;
          }
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function handlePollingBanks(_x) {
    return _ref.apply(this, arguments);
  };
}();